var slideStudySlide = function(global) {
    // clear it out
    var frame = $(global.slidestudy).find('.image-column .image-frame');
    frame.html('');

    var slide = global.slides[global.currentSlide];
    var str = '<img class="slide-image" src="'+ slide.image_url+'" />';
    var image = $.parseHTML(str);
    frame.append(image);

    $(global.slidestudy).find('.diagnosis span').html(slide.excerpt);

}


module.exports = slideStudySlide;


//////////////////
// WEBPACK FOOTER
// ./src/slidestudy_slide.js
// module id = 322
// module chunks = 0